
export default function Login({ onSubmit }) {

    return (
        <button className="btn btnRes btnHover btnLogin btnRadius btnWidthMedium textBoldHight" onClick={() => onSubmit("login")}>
            เข้าสู่ระบบ
        </button>
    );
}